"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Breadcrumbs = function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      classes = _ref.classes;
  return _react["default"].createElement(_Breadcrumbs["default"], {
    "aria-label": "Breadcrumb",
    separator: "|"
  }, breadcrumbs.map(function (crumb, index) {
    return crumb.link ? _react["default"].createElement(_Link["default"], {
      component: _reactRouterDom.Link,
      to: crumb.link,
      key: index,
      className: "".concat(classes.crumb, " + ").concat(index === breadcrumbs.length - 1 ? classes.current : classes.back)
    }, crumb.icon && _react["default"].createElement("span", {
      className: classes.icon
    }, _react["default"].createElement(_Icon["default"], {
      icon: crumb.icon,
      height: 20
    })), _react["default"].createElement("span", null, crumb.label)) : _react["default"].createElement("div", {
      key: index,
      className: "".concat(classes.crumb, " + ").concat(index === breadcrumbs.length - 1 ? classes.current : classes.back)
    }, crumb.icon && _react["default"].createElement("span", {
      className: classes.icon
    }, _react["default"].createElement(_Icon["default"], {
      icon: crumb.icon,
      height: 20
    })), _react["default"].createElement("span", null, crumb.label));
  }));
};

Breadcrumbs.propTypes = {
  breadcrumbs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    link: _propTypes["default"].string,
    icon: _propTypes["default"].string
  })).isRequired
};

var _default = (0, _styles2.withStyles)(_styles.styles)(Breadcrumbs);

exports["default"] = _default;